import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-load',
  templateUrl: './load.component.html',
  styleUrl: './load.component.css'
})
export class LoadComponent implements OnInit{

  @Input() size:any;
  constructor() { }

  ngOnInit(): void {
    if(!this.size){
      this.size='60';
    }
  }
}
